/** Tiny className combiner. Keeps the dependency list honest — this is all clsx does here. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
